import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import ChatIcon from "@mui/icons-material/Chat";

const ContactSupportSection: React.FC = () => {
  const [chatSnackbar, setChatSnackbar] = useState(false);

  return (
    <>
      <Paper
        sx={{
          mt: 6,
          p: { xs: 4, md: 6 },
          borderRadius: 2,
          textAlign: "center",
          background: "linear-gradient(135deg, #E0F2F1 0%, #B2DFDB 100%)",
          boxShadow: "none",
        }}
      >
        <Typography variant="h5" fontWeight={700} mb={1}>
          Still need help?
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={3}>
          Our support team is here for you
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<EmailIcon />}
            href="mailto:support@happypaws.com"
            sx={{
              textTransform: "none",
              backgroundColor: "#178B8E",
              "&:hover": { backgroundColor: "#146f72" },
              px: 3,
            }}
          >
            Email Support
          </Button>
          <Button
            variant="outlined"
            size="large"
            startIcon={<ChatIcon />}
            onClick={() => setChatSnackbar(true)}
            sx={{
              textTransform: "none",
              borderColor: "#178B8E",
              color: "#178B8E",
              "&:hover": { borderColor: "#146f72", backgroundColor: "rgba(23,139,142,0.05)" },
              px: 3,
            }}
          >
            Chat with Us
          </Button>
        </Stack>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Email: support@happypaws.com
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Response time: Within 24 hours
          </Typography>
        </Box>
      </Paper>

      <Snackbar
        open={chatSnackbar}
        autoHideDuration={3000}
        onClose={() => setChatSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="info" onClose={() => setChatSnackbar(false)}>
          Live chat is coming soon!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContactSupportSection;
